<div class="PartnerControl">
  <app-select
    *ngIf="column.account_role !== 'partner'"
    [items]="getPartners()"
    [defaultValue]="column.partner_id || null"
    [label]="'Select partner'"
    (selection)="onPartnerSelect($event)"></app-select>
  <a *ngIf="column.account_role === 'partner'" (click)="openDialog()"
    >Partner</a
  >
  <mat-icon *ngIf="column.partner_id" (click)="resetPartner()">close</mat-icon>
</div>
